interface IInfoArea {
    title: string,
    description: string,
    value: string
}

const InfoArea = ({ title, description, value }: IInfoArea) => {
    return (
        <div className='flex items-center'>
            <div className="w-[170px] text-lg leading-none shrink-0">
                <p className='mb-0.5'>{title}</p>
                <p className='text-[#9D9EB7]'>{description}</p>
            </div>
            <div className='bg-[#F8F8FA] px-6 py-3 rounded min-w-[600px] min-h-12'>
                {value && value}
            </div>
        </div>
    )
}

export default InfoArea